<template>
  <div>voucher</div>
</template>

<script>
export default {}
</script>

<style></style>
